'use client';

import React, { useEffect, useRef } from 'react';
import type { FieldValues } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import { Button } from '../Button';
import { AppTextInput } from '../formFields';

interface Props {
  backgroundImage: string;
}

export const GetAQuoteDrawerClient: React.FC<Props> = ({
  backgroundImage,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const { control, handleSubmit } = useForm();

  const onSubmit = (_: FieldValues) => {

  };

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  if (process.env.APP_ENV === 'production') return null;

  return (
    <div
      className={constructClassName([
        styles.container,
        isOpen && styles.containerIsOpen,
      ])}
      ref={containerRef}
    >
      <div className={styles.innerContainer}>
        <button
          type="button"
          className={styles.button}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span>
            Get a quote
          </span>
        </button>
        <div className={styles.settingsMenuContainer}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <AppTextInput
              control={control}
              name="postCode"
              label="Post code"
              placeholder="Post Code"
              required
            />
            <AppTextInput
              control={control}
              name="phoneNumber"
              label="Phone Number"
              placeholder="Phone Number"
              required
            />
            <Button
              htmlType="submit"
              className={styles.formSubmitButton}
              type="primary"
              title="Get my quote"
            >
              Submit
            </Button>
          </form>
          <img
            className={styles.decorativeImage}
            alt="Decorative background"
            src={backgroundImage}
          />
        </div>
      </div>
    </div>
  );
};
